export default "__VITE_ASSET__Cma7zm$G__"